import { HEADER_ACTION_BUTTON_SIZE } from "@/components/Header/Header.constants";
import { useShareLink } from "@/hooks/useShareLink/useShareLink";
import { Button, Tooltip, TooltipContent, TooltipTrigger } from "@aircall/ds";
import { Share2 } from "@aircall/react-icons";
import { useTranslation } from "react-i18next";

export function ShareLink() {
  const { t } = useTranslation();
  const handleOnClick = useShareLink();

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            data-test="player-share-link"
            onClick={handleOnClick}
            variant="ghost"
            size={HEADER_ACTION_BUTTON_SIZE}
            aria-label={t("copy_link")}
          />
        }
      >
        <Share2 className="size-4" />
      </TooltipTrigger>
      <TooltipContent>{t("copy_link")}</TooltipContent>
    </Tooltip>
  );
}
